module.exports = __webpack_public_path__ + "media/images/signup-paul-phelps-d5448e742ca9091e9f72d501d122dd4c.jpg";